import YHeader from './src/main'

YHeader.install = function(Vue) {
  Vue.component(YHeader.name, YHeader)
}

export default YHeader
